var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"breadcrumbs"},_vm._l((_vm.path),function(item,index){return _c('li',{key:index,staticClass:"breadcrumb"},[_c('router-link',{attrs:{"to":item.url ? item.url : '#'}},[_vm._v(_vm._s(item.name))])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }